export default function createSubOrderUpdate(updatedOrder, removedOrderId) {
	return {
		updatedOrder,
		removedOrderId
	};
}
